/**
 * Sequences overlapping async requests so only the most recent one's result
 * is applied: an older request that resolves after a newer one is dropped.
 *
 * Used for locale switching, where each switch loads a bundle and the
 * Profile screen's segmented control switches on every arrow-key press —
 * without this, two quick presses could resolve out of order and leave the
 * app in the language the user moved past.
 */
export function create_latest_wins(): <T>(
  request: Promise<T>,
  apply: (value: T) => void,
) => void {
  let latest = 0;
  return (request, apply) => {
    latest += 1;
    const id = latest;
    void request.then((value) => {
      if (id === latest) apply(value);
    });
  };
}
